var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('FormGroup',{style:({ width: '100%' }),attrs:{"small-label":"","required":""},scopedSlots:_vm._u([{key:"after-input",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},[_vm._t("select-applications")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }